export default "__VITE_ASSET__BmrLnCbq__"